import { render, staticRenderFns } from "./source-custom.vue?vue&type=template&id=0ac042d0&scoped=true&"
import script from "./source-custom.vue?vue&type=script&lang=js&"
export * from "./source-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac042d0",
  null
  
)

export default component.exports